import { ISmsCodeMutationResult, ISmsCodeStatusData } from 'types/smsCode.types';

export const getResultData = (mutationResult: ISmsCodeMutationResult): ISmsCodeStatusData => {
  const { isSuccess, isError, isLoading, error } = mutationResult;
  const resultData: ISmsCodeStatusData = {
    isSuccess,
    isLoading,
    isError,
  };

  const errorData = error?.data;

  if (errorData?.error) {
    resultData.errorMessage = `${errorData?.error} ${errorData?.validationErrors?.join(' ')}`;
  }

  if (errorData?.Error) {
    resultData.errorMessage = errorData?.Error;
  }

  return resultData;
}; 